import { format } from 'date-fns'
import React from 'react'

export default function ViewOnly({ entry }) {
  if (!entry) return null

  const allEmails = [entry.email, ...(entry.additional_emails || [])].filter(Boolean)
  const submittedAt = entry.submitted_at ? format(new Date(entry.submitted_at), 'MM/dd/yyyy hh:mm aa') : null

  return (
    <div className="compliance-form-view-only">
      <div className="dome-d-flex dome-flex-column dome-gap12">
        {allEmails.length > 0 && <div className="compliance-form-view-only-row dome-d-flex dome-align-start dome-gap12">
          <div className="compliance-form-view-only-address dome-p1 dome-text-w500 dome-flex-1">
            <div className='dome-p3 dome-text-w400'>mailing recipient</div>
            <div>{entry.full_name}</div>
          </div>
          <div className="compliance-form-view-only-emails dome-flex-1">
            <div className='dome-p3 dome-text-w400'>email(s)</div>
            {allEmails.map((email) => <div key={email} className='dome-color-aqua'>{email}</div>)}
          </div>
        </div>}
        {submittedAt && allEmails.length > 0 && (
          <div className="compliance-form-submitted-line dome-d-flex dome-align-center dome-justify-between">
            <em className="dome-p2 dome-color-med-grey">
              Certified {submittedAt}{entry.submitted_by_name ? ` by ${entry.submitted_by_name}` : ''}.
            </em>
          </div>
        )}
      </div>

    </div>
  )
}
